// extracted by mini-css-extract-plugin
export default {"input-box":"LostPlot_input-box__kWH3K","button":"LostPlot_button__qz+bY"};